import React from "react";
import { Header, Image } from "semantic-ui-react";

const PrestamoHeader = () => {
  return (
    <Header as="h1" color="blue">
      <Image src="/assets/icons/prestamo.svg" size="medium" /> Mis préstamos
    </Header>
  );
};

export default PrestamoHeader;
